<template>
  <div class="content-center">
    <div style="background-color: #cc007a">
      <div class="p-7 flex justify-center items-center">
        <a href="/"><img src="/images/logo_testo.png" /></a>
      </div>
      <div style="padding: 50px 20px" class="p-2 flex justify-center items-center">
        <span class="text-white text-center font-bold text-3xl">Seguici su </span>
      </div>
      <div class="mt-6 px-8 py-4 flex justify-center items-center">
        <a href='https://whatsapp.com/channel/0029VaVTWwp3GJOovIbNA63s'><button style="padding: 20px 75px;" class="btn-indigo" type="submit">WHATSAPP</button></a>
      </div>
      <div class="mt-6 px-8 py-4 flex justify-center items-center">
        <a href='https://streetstock.it'><button style="padding: 20px 75px;" class="btn-indigo" type="submit">SITO WEB</button></a>
      </div>
      <div class="mt-6 px-8 py-4 flex justify-center items-center">
        <a href='https://instagram.com/streetstock_market/'><button style="padding: 20px 64px;" class="btn-indigo" type="submit">INSTAGRAM</button></a>
      </div>
      <div class="mt-6 px-8 py-4 flex justify-center items-center">
        <a href='https://tiktok.com/@streetstockmarket1'><button style="padding: 20px 80px;" class="btn-indigo" type="submit">TIKTOK</button></a>
      </div>
      <div class="mt-6 px-8 py-4 flex justify-center items-center">
        <a href='https://www.facebook.com/streetstockitalia'><button style="padding: 20px 70px;" class="btn-indigo" type="submit">FACEBOOK</button></a>
      </div>
      <div class="mt-6 px-8 py-4 flex justify-center items-center">
      </div>
      <div class="mt-6 px-8 py-4 flex justify-center items-center">
      </div>
      <div class="mt-6 px-8 py-4 flex justify-center items-center">
      </div>

    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      options: {},
    }
  },
}
</script>